<template>
    <section class="content">
      <div class="box box-info">
      
      <div class="p-toolbar p-component mb-4">
        <crmTaskDialog ref="openDialog"/>
        </div>
          <a href="#"  @click.prevent="exportCSV()" v-if="this.crmTaskLists.length > 0">
            <img src="../../../../static/img/excel.png" style="margin-top: 1em;width: 4%;float: right;"/>
         </a>
      <DataTable ref="po"
      :value="crmTaskLists"
      :paginator="true"
      :rows="8" :filters="filters"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.n">
        <template #body="slotProps">
        {{slotProps.index+1}}
        </template>
      </Column>
      <Column :sortable="true"   header="Task Name" field="taskName" filterMatchMode="contains" >
         <template #filter>
           <InputText type="text" class="p-column-filter" v-model="filters['taskName']" />
         </template>
      </Column>
      <Column :sortable="true" header="task Type Name" field="taskTypeName" filterMatchMode="contains">
        <template #body="slotProps">
          {{ getTaskTypeLabel(slotProps.data.taskType) }}
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['taskTypeName']" />
        </template>
      </Column>

      <Column :sortable="true" header="callType" field="callType" filterMatchMode="contains">
        <template #body="slotProps">
          {{ getCallTypeLabel(slotProps.data.callType) }}
        </template>
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['callType']" />
        </template>
      </Column>

      <Column :sortable="true" header="priority Name" field="priorityName"
       filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['priorityName']" />
        </template>
      </Column>

       <Column :sortable="true" header="productId" field="productId" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['productId']" />
        </template>
      </Column>

      <Column :sortable="true" header="taskStatus" field="taskStatus" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['taskStatus']" />
        </template>
      </Column>
      <Column :sortable="true" header="stageId" field="stageId" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['stageId']" />
        </template>
      </Column>

      <Column :sortable="true" header="repeat" field="repeat" filterMatchMode="contains" >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['repeat']" />
        </template>
      </Column>

     <Column :sortable="true" header="taskDueDate" field="taskDueDate"
      filterMatchMode="contains" >
      <template #body="slotProps">
        {{ formatDate(slotProps.data.taskDueDate) }}
      </template>
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['taskDueDate']" />
        </template>
      </Column>

      <Column :sortable="true" header="reminderType" field="reminderType"
      filterMatchMode="contains" >
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['reminderType']" />
        </template>
      </Column>

      <Column :sortable="true" header="reminderDate" field="reminderDate"
      filterMatchMode="contains" >
      <template #body="slotProps">
        {{ formatDate(slotProps.data.reminderDate) }}
      </template>
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['reminderDate']" />
        </template>
      </Column>

      <Column :sortable="true" header="reminderTime" field="reminderTime"
      filterMatchMode="contains" >
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['reminderTime']" />
        </template>
      </Column>

      <Column :sortable="true" header="clientId" field="clientId"
      filterMatchMode="contains" >
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['clientId']" />
        </template>
      </Column>

      <Column :sortable="true" header="description" field="description"
      filterMatchMode="contains" >
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['description']" />
        </template>
      </Column>

    <Column header="Action" headerStyle="width: 11em">
        <template #body="slotProps">


            <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmTask(slotProps.data)" />

            <Button icon="pi pi-trash" class="p-button-danger p-button-sm"   @click="openDialog(slotProps.data.id)"/>

        </template>
      </Column>


      </DataTable>
     </div>
     <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteTask"/>

   </section>

</template>
<script>
import crmTaskDialog from '../crmDialog/crmTaskDialog.vue'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'

export default {
  name: 'customer',
  data() {
    return {
      displayBasic: false,
      dialogShow: false,
      columnList: '',
      callTypeMap: {
        0: 'Low',
        1: 'High'
      },
      filters: {}
    }
  },
  computed: {
    crmTaskLists() {
      return this.$store.state.crm.crmTaskLists
    },
    masterSetupList() {
      return this.$store.state.users.masterSetupList
    },
    sourceList() {
      return this.masterSetupList.filter(item =>
        item.name === 'source'
      )
    }
  },
  mounted() {
    this.crmTaskList()
    this.columnNames()
    this.masterSetupLists()
  },
  methods: {
    async masterSetupLists() {
      await this.$store.dispatch('loadMasterSetupList', 'Crm')
    },
    async deleteTask(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountMasterId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteCrmTask', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
        this.closeDialog()
        this.dialogShow = false
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.dialogShow = false
        this.closeDialog()
      }
    },
    editCrmTask(data) {
      this.$refs.openDialog.editCrmTask(data)
    },
    getTaskTypeLabel(value) {
      const sourceItem = this.sourceList.find(item => item.id === value)
      return sourceItem ? sourceItem.value : 'N/A'
    },
    getCallTypeLabel(value) {
      return this.callTypeMap[value] || 'N/A'
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString()
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Customer List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'customerList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    async crmTaskList() {
      await this.$store.dispatch('loadCrmTaskList')
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    },
    cancel(data) {
      this.dialogShow = false
    }
  },
  components: {
    Column,
    DataTable,
    Dialog,
    InputText,
    crmTaskDialog,
    Button
  }
}
</script>



// WEBPACK FOOTER //
// crmTaskDetails.vue?07011c8e